import { intlDateWithTimezone } from "@faire/web--source/common/localization/date-fns/intlDate";
import { PromotionalEventType } from "@faire/web-api--source/indigofair/common/PromotionalEventType";
var MARKET_TIMEZONE = "America/Toronto";
export var MARKET_FALLBACKS = function(strictLocalize) {
    return {
        currentEventType: PromotionalEventType.FAIRE_MARKET_JANUARY_2025,
        name: "Faire Market",
        /* Below variables are used for date ranges.
     * Currently our localization for date ranges aren't good enough
     * context: https://github.com/Faire/web/pull/2195
     * Use dates from DB for date ranges once we have a solution
     */ month: strictLocalize({
            id: "8W5Jnq",
            defaultMessage: [
                {
                    type: 0,
                    value: "January"
                }
            ]
        }),
        earlyAccessDayNumber: "21",
        startDayNumber: "22",
        endDayNumber: "24",
        yearNumber: "2025",
        earlyAccessStartAtTimestamp: 1737435600000,
        mainEventStartAtTimestamp: 1737522000000,
        endAtTimestamp: 1737781199000
    };
};
var formatDateInMarketTimezone = function(value) {
    var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "MMMM d";
    return intlDateWithTimezone(value, format, MARKET_TIMEZONE);
};
var generateFormattedRange = function(dates, options, strictLocalize) {
    var startMonthDate = dates.startMonthDate, startDayNumber = dates.startDayNumber, endMonthDate = dates.endMonthDate, endDayNumber = dates.endDayNumber, yearNumber = dates.yearNumber;
    var hasYear = options.hasYear, hasEndMonth = options.hasEndMonth;
    if (hasYear && yearNumber) {
        if (hasEndMonth && endMonthDate) {
            return strictLocalize({
                id: "EB2pAY",
                defaultMessage: [
                    {
                        type: 1,
                        value: "startMonthDate"
                    },
                    {
                        type: 0,
                        value: " "
                    },
                    {
                        type: 1,
                        value: "startDayNumber"
                    },
                    {
                        type: 0,
                        value: " to "
                    },
                    {
                        type: 1,
                        value: "endMonthDate"
                    },
                    {
                        type: 0,
                        value: " "
                    },
                    {
                        type: 1,
                        value: "endDayNumber"
                    },
                    {
                        type: 0,
                        value: ", "
                    },
                    {
                        type: 1,
                        value: "yearNumber"
                    }
                ]
            }, {
                startMonthDate: startMonthDate,
                startDayNumber: startDayNumber,
                endMonthDate: endMonthDate,
                endDayNumber: endDayNumber,
                yearNumber: yearNumber
            });
        }
        return strictLocalize({
            id: "dHuXIe",
            defaultMessage: [
                {
                    type: 1,
                    value: "monthDate"
                },
                {
                    type: 0,
                    value: " "
                },
                {
                    type: 1,
                    value: "startDayNumber"
                },
                {
                    type: 0,
                    value: " to "
                },
                {
                    type: 1,
                    value: "endDayNumber"
                },
                {
                    type: 0,
                    value: ", "
                },
                {
                    type: 1,
                    value: "yearNumber"
                }
            ]
        }, {
            monthDate: startMonthDate,
            startDayNumber: startDayNumber,
            endDayNumber: endDayNumber,
            yearNumber: yearNumber
        });
    }
    if (hasEndMonth && endMonthDate) {
        return strictLocalize({
            id: "kWHiVu",
            defaultMessage: [
                {
                    type: 1,
                    value: "startMonthDate"
                },
                {
                    type: 0,
                    value: " "
                },
                {
                    type: 1,
                    value: "startDayNumber"
                },
                {
                    type: 0,
                    value: " to "
                },
                {
                    type: 1,
                    value: "endMonthDate"
                },
                {
                    type: 0,
                    value: " "
                },
                {
                    type: 1,
                    value: "endDayNumber"
                }
            ]
        }, {
            startMonthDate: startMonthDate,
            startDayNumber: startDayNumber,
            endMonthDate: endMonthDate,
            endDayNumber: endDayNumber
        });
    }
    return strictLocalize({
        id: "OiKQt/",
        defaultMessage: [
            {
                type: 1,
                value: "monthDate"
            },
            {
                type: 0,
                value: " "
            },
            {
                type: 1,
                value: "startDayNumber"
            },
            {
                type: 0,
                value: " to "
            },
            {
                type: 1,
                value: "endDayNumber"
            }
        ]
    }, {
        monthDate: startMonthDate,
        startDayNumber: startDayNumber,
        endDayNumber: endDayNumber
    });
};
var earlyAccessRangeDate = function(strictLocalize, event) {
    return getDateRange(strictLocalize, event, true);
};
var mainEventRangeDate = function(strictLocalize, event) {
    return getDateRange(strictLocalize, event);
};
// For strings that only show the market dates, languages other than English want to prepend "From" to the string
var getLocalizedDateIncludingFrom = function(date, strictLocalize) {
    return strictLocalize({
        id: "xbSlnO",
        defaultMessage: [
            {
                type: 1,
                value: "Date"
            }
        ]
    }, {
        Date: date
    });
};
var getDateRange = function(strictLocalize, event, isEarlyAccess, includeYear, year) {
    var earlyAccessStartDay = (event === null || event === void 0 ? void 0 : event.insider_early_access_start_at) ? intlDateWithTimezone(event.insider_early_access_start_at, "d", MARKET_TIMEZONE) : MARKET_FALLBACKS(strictLocalize).earlyAccessDayNumber;
    var startDay = (event === null || event === void 0 ? void 0 : event.start_at) ? intlDateWithTimezone(event.start_at, "d", MARKET_TIMEZONE) : MARKET_FALLBACKS(strictLocalize).startDayNumber;
    var endDay = (event === null || event === void 0 ? void 0 : event.end_at) ? intlDateWithTimezone(event.end_at, "d", MARKET_TIMEZONE) : MARKET_FALLBACKS(strictLocalize).endDayNumber;
    var startMonth = (event === null || event === void 0 ? void 0 : event.start_at) ? intlDateWithTimezone(event.start_at, "MMMM", MARKET_TIMEZONE) : MARKET_FALLBACKS(strictLocalize).month;
    var endMonth = (event === null || event === void 0 ? void 0 : event.end_at) ? intlDateWithTimezone(event.end_at, "MMMM", MARKET_TIMEZONE) : undefined;
    var yearNumber = year !== null && year !== void 0 ? year : MARKET_FALLBACKS(strictLocalize).yearNumber;
    return generateFormattedRange({
        startDayNumber: isEarlyAccess ? earlyAccessStartDay : startDay,
        endDayNumber: endDay,
        startMonthDate: startMonth,
        endMonthDate: !includeYear ? endMonth : undefined,
        yearNumber: includeYear ? yearNumber : undefined
    }, {
        hasYear: includeYear,
        hasEndMonth: false
    }, strictLocalize);
};
export var getFaireMarketUtils = function(marketYear, strictLocalize) {
    var fallbacks = MARKET_FALLBACKS(strictLocalize);
    var earlyAccessAndYearRangeDate = generateFormattedRange({
        startDayNumber: fallbacks.earlyAccessDayNumber,
        endDayNumber: fallbacks.endDayNumber,
        startMonthDate: fallbacks.month,
        yearNumber: marketYear !== null && marketYear !== void 0 ? marketYear : fallbacks.yearNumber
    }, {
        hasYear: true,
        hasEndMonth: false
    }, strictLocalize);
    var earlyAccessRangeDateWithYear = function(strictLocalize, event) {
        return getDateRange(strictLocalize, event, true, true, marketYear !== null && marketYear !== void 0 ? marketYear : fallbacks.yearNumber);
    };
    return {
        formatDateInMarketTimezone: formatDateInMarketTimezone,
        generateFormattedRange: generateFormattedRange,
        /**
         * @deprecated use earlyAccessRangeDateWithYear instead so that dates from BE are used and hardcoded dates are only a fallback.
         */ earlyAccessAndYearRangeDate: earlyAccessAndYearRangeDate,
        earlyAccessRangeDate: earlyAccessRangeDate,
        mainEventRangeDate: mainEventRangeDate,
        getLocalizedDateIncludingFrom: getLocalizedDateIncludingFrom,
        earlyAccessRangeDateWithYear: earlyAccessRangeDateWithYear,
        MARKET_TIMEZONE: MARKET_TIMEZONE
    };
};
